module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/smile-349f43a446fd3e94e144fd6f0295bd49.svg";